export default Object.freeze({
    unknown: 'unknown',
    poor: 'poor',
    fair: 'fair',
    good: 'good',
    approved: 'approved',
});
